var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWossip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13104 -1857)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-13104 1857)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13100.713 1862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4987.947-2505.762v-.558q0-3.519,0-7.039c0-1.012-.188-1.2-1.181-1.2h-12.733c-.917,0-1.161.238-1.161,1.141v19.4c0,.916.242,1.161,1.141,1.161q5.372,0,10.743-.007a.826.826,0,0,1,.721.365c.583.71,1.222,1.374,1.831,2.05a.21.21,0,0,1-.121.038c-4.415,0-8.831-.05-13.244,0a3.427,3.427,0,0,1-3.5-3.495c.027-6.544.008-13.089.01-19.634a3.352,3.352,0,0,1,3.463-3.485q6.505-.011,13.012,0a3.332,3.332,0,0,1,3.447,3.361c.037,2.191.012,4.384,0,6.575a.574.574,0,0,1-.222.439c-.662.324-1.343.606-2.019.9C4988.113-2505.741,4988.078-2505.754,4987.947-2505.762Z",
    transform: "translate(-4970.447 2517.032)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5029.614-2444.619c1.233,0,2.467-.014,3.7,0a1.173,1.173,0,0,1,1.049,1.817,1.213,1.213,0,0,1-1.132.6c-2.42.018-4.841.023-7.261,0a1.226,1.226,0,0,1-1.171-1.82,1.148,1.148,0,0,1,1.115-.6C5027.147-2444.615,5028.38-2444.619,5029.614-2444.619Z",
    transform: "translate(-5019.617 2451.332)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5029.7-2388.338c-1.22,0-2.439,0-3.659,0a1.149,1.149,0,0,1-1.289-1.191,1.146,1.146,0,0,1,1.263-1.182q3.681-.015,7.364,0a1.16,1.16,0,0,1,1.271,1.18,1.158,1.158,0,0,1-1.291,1.192C5032.144-2388.334,5030.923-2388.338,5029.7-2388.338Z",
    transform: "translate(-5019.726 2402.42)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5027.448-2334.151a14.59,14.59,0,0,1-1.61-.133,1.047,1.047,0,0,1-.9-1.2,1.019,1.019,0,0,1,1-1.107,26.678,26.678,0,0,1,2.9.008,1.112,1.112,0,0,1,.98,1.109,1.133,1.133,0,0,1-.819,1.153A13.933,13.933,0,0,1,5027.448-2334.151Z",
    transform: "translate(-5019.884 2353.341)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5176.184-2332.321c.171-.154.275-.24.37-.334q1.1-1.093,2.191-2.189a2.566,2.566,0,0,1,.215-.207.636.636,0,0,1,.879.023.616.616,0,0,1,.009.876q-1.529,1.581-3.086,3.135a.712.712,0,0,1-1.01-.021q-.767-.762-1.507-1.551a.573.573,0,0,1,.016-.862.592.592,0,0,1,.862.01C5175.48-2333.082,5175.82-2332.706,5176.184-2332.321Z",
    transform: "translate(-5155.193 2352.059)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5176.277-2330.317a1.241,1.241,0,0,1-.878-.366c-.516-.513-1.027-1.039-1.519-1.564a1.067,1.067,0,0,1,.026-1.557,1.093,1.093,0,0,1,.777-.328,1.12,1.12,0,0,1,.793.338c.25.25.483.5.73.765l.007.008q.828-.825,1.655-1.653l.524-.524.054-.055a1.922,1.922,0,0,1,.208-.193,1.213,1.213,0,0,1,.753-.27,1.083,1.083,0,0,1,.8.345,1.119,1.119,0,0,1,0,1.566c-1.039,1.074-2.08,2.131-3.093,3.141A1.178,1.178,0,0,1,5176.277-2330.317Zm-1.594-2.815a.1.1,0,0,0-.068.034c-.081.081-.07.1-.005.168.484.516.987,1.034,1.495,1.539a.25.25,0,0,0,.173.075.18.18,0,0,0,.132-.054c1.009-1.006,2.045-2.059,3.08-3.129.054-.056.05-.118-.014-.185a.087.087,0,0,0-.068-.03.235.235,0,0,0-.137.057,1.152,1.152,0,0,0-.106.1l-.067.068-.521.522q-.833.833-1.667,1.666c-.075.074-.148.139-.242.221l-.147.131-.362.325-.335-.354c-.118-.125-.232-.248-.347-.37-.241-.258-.468-.5-.706-.74A.132.132,0,0,0,5174.683-2333.132Z",
    transform: "translate(-5155.193 2352.059)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5132.053-2393.278a7.579,7.579,0,0,0-7.579,7.578,7.579,7.579,0,0,0,7.579,7.579,7.579,7.579,0,0,0,7.579-7.579A7.579,7.579,0,0,0,5132.053-2393.278Zm0,13.072a5.493,5.493,0,0,1-5.494-5.493,5.494,5.494,0,0,1,5.494-5.494,5.493,5.493,0,0,1,5.494,5.494A5.493,5.493,0,0,1,5132.053-2380.206Z",
    transform: "translate(-5110.205 2404.743)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWossip);
export default __webpack_public_path__ + "static/media/wossip.985c1cbf.svg";
export { ForwardRef as ReactComponent };